import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import Icon from 'components/Icon';
import Popper from 'components/Popper';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { useTimerContext } from 'features/timer/RoomTimerContext';
import TimerPill from 'features/timer/components/TimerPill';
import { getTimerBackgroundColor } from 'features/timer/utils/getTimerBackgroundColor';

const PopperContent = memo(() => {
  const { timer } = useTimerContext();

  if (!timer) {
    return null;
  }

  return (
    <Box
      sx={{
        minWidth: '80px',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="body2"
        component="span"
        sx={{
          fontFamily: 'monospace',
          fontSize: '0.875rem',
        }}
      >
        {timer.data.formattedTime}
      </Typography>
    </Box>
  );
});

const TopBarTimer = () => {
  const { timer, isActive } = useTimerContext();

  const { isMobile } = useBreakpoints();

  if (!timer) {
    return null;
  }

  if (isMobile) {
    return (
      <Popper id="top-bar-timer" placement="bottom" arrow={false} content={<PopperContent />}>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            p: 1,
            borderRadius: '8px',
            backgroundColor: getTimerBackgroundColor(timer.data.currentSeconds, isActive),
            color: 'common.white',
          }}
        >
          <Icon
            sx={{
              fontSize: 24,
            }}
            name={timer.data.mode === 'countdown' ? 'timer' : 'stop-watch'}
          />
        </Box>
      </Popper>
    );
  }

  return (
    <TimerPill
      currentSeconds={timer.data.currentSeconds}
      isActive={isActive}
      formattedTime={timer.data.formattedTime}
      mode={timer.data.mode}
    />
  );
};

export default TopBarTimer;
